import 'Styles/templates/page.press.scss';

const cwf = document.querySelector('.pg');
const openTriggers = cwf.querySelectorAll('[data-modal-trigger]');
const pressModal = cwf.querySelector('.pg__modal');
const closeBtn = cwf.querySelector('.pg__modal-close');
let currentParent = null;

openTriggers.forEach((trigger) => {
  trigger.addEventListener('click', (e) => {
    let modalContent = e.currentTarget.nextElementSibling;
    currentParent = e.currentTarget;
    modalContent.classList.add('active');
    pressModal.appendChild(modalContent);
    pressModal.classList.toggle('is--open');
  });
});

closeBtn.addEventListener('click', (e) => {
  const modalContent = e.target.nextElementSibling;
  modalContent.classList.remove('active');
  currentParent.appendChild(modalContent);
  currentParent.insertAdjacentElement('afterend', modalContent);
  currentParent = null;
  pressModal.classList.remove('is--open');
});
